export const TextAreaForm = ({
  label,
  sublabel,
  placeholder,
  validation,
  submit,
  name,
  value,
  onInputChange,
  rows = 3,
}) => {
  return (
    <div>
      {label && (
        <label className="form-label">
          {label} <span className="text-danger"></span>
          <span className="text-danger" style={{ fontSize: "10px" }}>
            {sublabel}
          </span>
        </label>
      )}
      <textarea
        style={{ fontFamily: "Inter, sans-serif" }}
        className={`form-control ${validation && submit && "border-danger"}`}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onInputChange}
        rows={rows}
      ></textarea>
      {validation && submit && (
        <span className="text-danger">{validation}</span>
      )}
    </div>
  );
};
